export interface IValidation {
    surgeryDate: boolean,
    donorUnosId: boolean,
    donorAlias: boolean,
    donorEmail: boolean,
    donorAboType: boolean,
    donorGender: boolean,
    donorName: boolean,
    donorAddressLine1: boolean,
    donorCity: boolean,
    donorState: boolean,
    donorPostalCode: boolean,
    donorPhoneNumber: boolean,
    donorBirthdate: boolean,
    organType: boolean,
    recipientAlias: boolean,
    recipientFirstName: boolean,
    recipientLastName: boolean,
    recipientAboType: boolean,
    recipientGender: boolean,
    recipientBirthdate: boolean,
    recipientPrimaryInsurance: boolean,
    recipientUnosCpra: boolean,
    recipientAliasDuplicate: boolean,
    surgeryBilled: boolean,
    surgeryInsurance: boolean
}